var _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBackdropSl3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 22,
    viewBox: "0 0 73 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36.5,
    r: 36.5,
    fill: "#0CCE6B",
    fillOpacity: 0.18
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackdropSl3);
export default __webpack_public_path__ + "static/media/backdrop-SL3.0087b94a69ee7aa81d217be806b1c281.svg";
export { ForwardRef as ReactComponent };